import React from 'react';
import styles from './FiltersBar.module.scss';
import { IAppliedFilter, IFilterableField } from './filters';
import { FiltersModal } from './FiltersModal';
import { useModalState } from 'v2/hooks/useModalState';
import SearchBar from '../SearchBar/SearchBar';
import classnames from 'classnames';

interface IFiltersBarProps {
  filterableFields: IFilterableField[];
  filters: IAppliedFilter[];
  searchText: string;
  onFiltersChange: (newAppliedFilters: IAppliedFilter[]) => void;
  onSearchChange: (search: string) => void;
}

export const FiltersBar = ({
  filterableFields,
  filters,
  searchText,
  onFiltersChange,
  onSearchChange,
}: IFiltersBarProps) => {
  const modalState = useModalState(false);

  const handleClearAllFilters = () => {
    onFiltersChange([]);
  };

  const handleSearchText = (text: string) => {
    onSearchChange(text);
  };

  const filterCount = filters?.length ?? 0;
  const filtersButtonString =
    filterCount > 0 ? `Filters (${filterCount})` : 'Filters';

  const showSearchBar = filterCount === 0;

  return (
    <>
      <div className={styles.bar}>
        <div className={styles.filterButtonGroup}>
          <button
            onClick={modalState.handleShow}
            className={classnames(styles.filters)}
          >
            <div className="inner">
              <div className="part1">{filtersButtonString}</div>
              <div>+</div>
            </div>
          </button>
          <button
            className={classnames('btn btn-tertiary', styles.clearAll)}
            onClick={handleClearAllFilters}
          >
            <span>Clear All</span>
          </button>
        </div>
        <div className={styles.search}>
          {showSearchBar && (
            <SearchBar
              placeHolder="Search"
              onSearch={handleSearchText}
              currentText={searchText}
            />
          )}
        </div>
      </div>
      <FiltersModal
        onFiltersChanged={onFiltersChange}
        filterableFields={filterableFields}
        filters={filters}
        {...modalState}
      />
    </>
  );
};
